export default "__VITE_ASSET__139df0c3__"